export enum FrameFileType {
  FRAMES = 'frames',
  FRAME_GROUPS = 'frame-groups',
}
